import axios from "axios";
import { mapGetters } from "vuex";
import pageMixin from '~/mixins/page.js';
import tableMixin from '~/mixins/table.js';
export default {
    mixins: [
        pageMixin,
        tableMixin
    ],
    methods: {

        createQuery(tableName, { columnFilterValue = {} }){
            let query = {
                where: {},
                order: {}
            }
            
            let fieldFilters = this.tables[tableName].fields.filter(
                field => {
                    return field._filter 
                    && (typeof field._filter === 'object') 
                        && !Array.isArray(field._filter)
                            && field._filter.active
                                && field._filter.value
                });

            // Load filedFilters
            for(const fieldFilter of fieldFilters){
                query.where = {
                    ...query.where,
                    [fieldFilter.key]: {
                        condition: fieldFilter._filter.condition,
                        value: fieldFilter._filter.value,
                        expressionType: fieldFilter._filter.expressionType
                    }
                }
            }

            for (const key in columnFilterValue) {
                if(columnFilterValue[key] !== '' ){
                    query.where = {
                        ...query.where,
                        [key]: {
                            condition: 'like',
                            value: `%${columnFilterValue[key]}%`,
                            expressionType: "filter"
                        }
                    }
                }
                
            }
            for (const key in query.order) {
                if (Object.hasOwnProperty.call(query.order, key)) {
                    const orderElement = query.order[key];
                    if(!orderElement){
                        delete query.order[key];
                    }
                }
            }

            if(!query.order || JSON.stringify(query.order) === '{}'){
                delete query.order
            }
            if(!query.where || JSON.stringify(query.where) === '{}'){
                delete query.where
            }
            
            return query;
        },

        /**
         * @param {*} object { tableName, url, method }
         * @description Carga los datos de una tabla desde una url
         */
        async updateTable({ tableName, fetch, url, method = 'GET', customFields, adapterFilters }) {

            let from = this.storeFrom;
            let to = this.storeTo;
            let rows = this.tables[tableName].rows;
            let lastEvaluatedKey = this.tables[tableName].lastEvaluatedKey;
            let totalPages = this.tables[tableName].totalPages;
            let columnFilterValue = this.tables[tableName].columnFilterValue;
            let matchResponse = this.tables[tableName].matchResponse || '_items';
            this.tables[tableName].loading = true;

            /** Create table filter */

            let tableFilter = this.createQuery(tableName, { columnFilterValue });

            if(!url && this.tables[tableName].url){
                url = this.tables[tableName].url;
            }

            let tableData = await this.fetcher({
                url,
                method,
                query: {
                    query: tableFilter,
                    rows,
                    lastEvaluatedKey
                },
                ...fetch
            });
            this.tables[tableName].totalPages += 1;
            this.tables[tableName].lastEvaluatedKey = tableData.lastEvaluatedKey;
            this.tables[tableName].items = this.normalizeArrayData({
                data: tableData[matchResponse]
            });

            this.tables[tableName].loading = false;
            console.log(this.getTableFieldsFromFirstItem({ tableName }));
            this.$store.dispatch('page/updateTables', {
                ...this.tables[tableName],
                name: tableName,
                allFields: this.getTableFieldsFromFirstItem({ tableName }),
            });
            this.tables[tableName].allFields = this.getStoreTableFields(tableName);
        }
    },
    async mounted() {
        this.checkStoreConfig();
    },
}